export function formatDaysInMentorship(value: unknown): string {
  if (value == null || value === "") return "—";
  const days = typeof value === "number" ? value : Number(value);
  if (!Number.isInteger(days) || days < 0) return "—";
  return days === 1 ? "1 day" : `${days} days`;
}
